// Security Monitoring Client-Side
// Logs important security events for debugging and monitoring

import {SESSION_EXPIRED_EVENT} from '../auth/authStatus.js';

const SECURITY_LOG_PREFIX = '[Security]';

export function logAuthEvent(event, details = {}) {
    const timestamp = new Date().toISOString();
    const logData = {
        timestamp,
        event,
        ...details,
        userAgent: navigator.userAgent,
        url: window.location.href,
    };
    
    // Log to console with appropriate level
    switch (event) {
        case 'auth_success':
            console.info(SECURITY_LOG_PREFIX, 'Authentication successful', logData);
            break;
        case 'auth_failure':
            console.warn(SECURITY_LOG_PREFIX, 'Authentication failed', logData);
            break;
        case 'token_refresh_success':
            console.debug(SECURITY_LOG_PREFIX, 'Token refreshed', logData);
            break;
        case 'token_refresh_failure':
            console.error(SECURITY_LOG_PREFIX, 'Token refresh failed', logData);
            break;
        case 'session_expired':
            console.warn(SECURITY_LOG_PREFIX, 'Session expired', logData);
            break;
        case 'unauthorized_access':
            console.warn(SECURITY_LOG_PREFIX, 'Unauthorized access attempt', logData);
            break;
        case 'suspicious_activity':
            console.error(SECURITY_LOG_PREFIX, 'Suspicious activity detected', logData);
            break;
        default:
            console.log(SECURITY_LOG_PREFIX, event, logData);
    }
    
    // In production, you could send to analytics or monitoring service
    // Example: sendToAnalytics('security_event', logData);
}

export function startSecurityMonitoring() {
    window.addEventListener(SESSION_EXPIRED_EVENT, (event) => {
        logAuthEvent('session_expired', {
            reason: event.detail?.error || 'Unknown',
        });
    });
}
